import FacetedSearch from './layouts/facetedSearch';
import ProductDetails from './layouts/productDetails';
import LocationDetails from './layouts/locationDetails';
import Default from './layouts/default';

const selectors = {
  youtubeContainer: '.floating-elements__youtube-livestream',
};

const LAYOUT_MAPPING = {
  default: Default,
  'faceted-search': FacetedSearch,
  'location-details': LocationDetails,
  'product-details': ProductDetails,
};

export { LAYOUT_MAPPING, selectors };
